import React, {useState} from "react";
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";
import ProjectionsUpload from "./Components/ProjectionsUpload";
import VersionSelect from "./Components/VersionSelect";
import AirflowDagLogs from "../Components/airflow/dagLogs/AirflowDagLogs";
import UploadTemplateHelp from "./Components/UploadTemplateHelp";
import {uploadTemplates} from "./uploadTemplates";

const ProjectionUniverseUpload = () => {
    const [loadingCSV, setLoadingCSV] = useState(false)

    const universeOptions = [
        {label: "NATURAL ENHANCED", value: "natural enhanced"},
        {label: "REGIONAL GROCERY", value: "regional grocery"},
        {label: "SPINS PET", value: "spins pet"},
        {label: "CIRCANA PET", value: "circana pet"},
        {label: "INFRA", value: "infra"},
        {label: "C AND S", value: "c and s"}
    ]
    const [universeName, setUniverseName] = useState(undefined);
    const [version, setVersion] = useState("");
    const [dagLogsRefreshTrigger, setDagLogsRefreshTrigger] = useState(undefined);
    const dag_name = 'edp_projection_universe';

    return (
        <>
            {!loadingCSV &&
                <div className={'projection-upload-trigger-dag-page-controls'}>
                    <div className={'projection-upload-select-container'}>
                        <SelectDropdown id={'universe_dropdown'}
                                        inputLabel={"Universe"}
                                        options={universeOptions}
                                        onChange={(e) => setUniverseName(e.value)}
                                        selectValue={universeName}
                                        selectLabel={universeOptions?.find(option => option.value === universeName)?.label}
                        />
                    </div>
                    <div className={'projection-upload-select-container'}>
                        <VersionSelect version={version} setVersion={setVersion} restrictToAvailableVersions={true} />
                    </div>
                    <ProjectionsUpload
                        getUploadUrl={() => `${process.env.REACT_APP_EDP_API_BASE_URL}/uploadUniverse`}
                        getUploadAdditionalData={() => ({version: version.trim(), universe: universeName.replaceAll(' ', '_')})}
                        getDagName={() => dag_name}
                        getDagRunConf={(file) => ({
                            input_filepath: `gs://${process.env.REACT_APP_GCS_DATA_BASE_URL}/p_data=projection_universe/${universeName.replaceAll(' ', '_')}/p_version=${version.trim()}/${file.name}`,
                            universe: universeName,
                            version: version.trim(),
                            report_output_gcs_path: `gs://${process.env.REACT_APP_GCS_TMP_BASE_URL}${dag_name}/${universeName.replaceAll(' ', '_')}/${version.trim()}/${file.name}-match-report.csv`
                        } )}
                        setLoading={setLoadingCSV}
                        setDisabled={!universeName || !version.trim()}
                        onDagTriggered={() => setDagLogsRefreshTrigger(Date.now())}
                    />
                    <UploadTemplateHelp template={uploadTemplates.universe}/>
                </div>
            }
            <div className="sld-dag-airflowlogs-container" data-testid="airflow-logs-container">
                <h5>DAG Run Logs</h5>
                <AirflowDagLogs
                    processName={dag_name}
                    includeVersion={true}
                    setAutoRefresh={true}
                    refreshTrigger={dagLogsRefreshTrigger}
                    customColumns={[
                        {
                            header: 'Universe',
                            accessorKey: 'conf.universe',
                            className: 'non-numeric-field'
                        },
                        {
                            header: 'Input Filepath',
                            accessorKey: 'conf.input_filepath',
                            className: 'non-numeric-field'
                        },
                        {
                            header: 'Match Report',
                            accessorKey: 'conf.report_output_gcs_path',
                            className: 'non-numeric-field',
                            cell: ({row, getValue}) => (row.original.is_complete && getValue())
                                ? <div className="open-json-payload-modal">
                                    <a className="button tertiary"
                                       href={getValue().replace("gs://", "https://storage.cloud.google.com/")}
                                       target="_blank"
                                       rel="noreferrer">Download</a>
                                </div>
                                : null
                        }
                    ]}
                />
            </div>
        </>

    )
}

export default ProjectionUniverseUpload;